import React, { Dispatch, SetStateAction } from "react";
import { TimeSlider } from "./TimeSlider/TimeSlider";
import { ContrastSlider } from "./ContrastSlider/ContrastSlider";
import { COLORS } from "../theme";

interface ControlsContainerProps {
    imageIndex: number;
    setImageIndex: Dispatch<SetStateAction<number>>;
    isPlaying: boolean;
    setIsPlaying: Dispatch<SetStateAction<boolean>>;
    totalImages: number;
    fdlmcpParams: any;
    formParams: any;
    minContrast: number;
    maxContrast: number;
    onMinChange: (value: number) => void;
    onMaxChange: (value: number) => void;
    onReset: () => void;
    disabled: boolean;
    isMobileDevice?: boolean;
}

export const ControlsContainer: React.FC<ControlsContainerProps> = ({
    imageIndex,
    setImageIndex,
    isPlaying,
    setIsPlaying,
    totalImages,
    fdlmcpParams,
    formParams,
    minContrast,
    maxContrast,
    onMinChange,
    onMaxChange,
    onReset,
    disabled,
    isMobileDevice = false
}) => {
    return (
        <div style={{
            padding: isMobileDevice ? '12px' : '20px',
            background: COLORS.bottomRightPane,
            borderRadius: '8px',
            marginBottom: '20px',
            border: `1px solid ${COLORS.focusBorder}`,
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
        }}>

            {/* TimeSlider */}
            <div style={{ display: 'flex', justifyContent: 'center', marginBottom: isMobileDevice ? '8px' : '20px' }}>
                <TimeSlider
                    imageIndex={imageIndex}
                    setImageIndex={setImageIndex}
                    isPlaying={isPlaying}
                    setIsPlaying={setIsPlaying}
                    totalImages={totalImages}
                    fdlmcpParams={fdlmcpParams}
                    formParams={formParams}
                />
            </div>

            {/* Contrast Slider - hidden on mobile */}
            {!isMobileDevice && (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <ContrastSlider
                        minPercent={minContrast}
                        maxPercent={maxContrast}
                        onMinChange={onMinChange}
                        onMaxChange={onMaxChange}
                        onReset={onReset}
                        disabled={disabled}
                    />
                </div>
            )}
        </div>
    );
}; 